import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import styles from "../styles/news-widget.module.scss";
import classNames from "classnames";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const NewsWidgetAsyncComponent = AsyncComponent(async () => import('./news-widget' /* webpackChunkName: "news-widget" */ ));

export const NewsWidgetAsync = (props) => {
  return <ErrorBoundaryWrapper>
    <React.Suspense fallback={<div className={classNames(styles.placeholder, {[styles.small_view_placeholder]: props.controller?.device.isSmallView}, props.className)}/>}>
      <NewsWidgetAsyncComponent {...props}/>
    </React.Suspense>
  </ErrorBoundaryWrapper>
};
